import LayoutARSkincare from 'components/Content/ContentLayout/LayoutARSkincare/LayoutARSkincare';
import { withLayoutARSkincareProps } from 'viewModel/content/layoutARSkincare/withLayoutARSkincareProps';

export default withLayoutARSkincareProps(LayoutARSkincare);
